
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from '@/components/ui/button';
import { Calculator } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import { estimateDeductions } from '../../utils/taxEstimates';

export function EstimateDeductionsButton() {
  const { toast } = useToast();
  const form = useFormContext();

  const handleEstimateDeductions = () => {
    const grossIncomeField = form.getValues('grossIncome');
    const grossIncome = Number(grossIncomeField);

    if (!grossIncome || grossIncome <= 0) {
      toast({
        title: "Please enter your gross income first",
        description: "We need your annual gross income to estimate deductions.",
        variant: "destructive"
      });
      return;
    }

    const estimates = estimateDeductions(grossIncome);
    Object.entries(estimates).forEach(([field, value]) => {
      form.setValue(field, value);
    });

    toast({
      title: "Deductions Estimated",
      description: "We've filled in estimated values based on your gross income. You can adjust these if needed.",
    });
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="border-grandpal-green text-grandpal-green hover:bg-grandpal-green/10"
      onClick={handleEstimateDeductions}
    >
      <Calculator className="w-4 h-4 mr-2" />
      Estimate Deductions
    </Button>
  );
}
